import OBTHoldingTier from "@/models/holding-tier/OBTHoldingTier";
import camelcaseKeys from "camelcase-keys";
import Vue from "vue";
import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";

/**
 * 🧩 Module which holds the general user information
 */
@Module
export default class OBTHoldingTierModule extends VuexModule {
  /**
   * 📦 The current user's holding tier based on the number of OBT they hold
   */
  public allOBTHoldingTiers?: OBTHoldingTier[];

  /**
   * 📦 The current user's holding tier based on the number of OBT they hold
   */
  public currentOBTHoldingTier?: OBTHoldingTier;

  /**
   * 👾 Updates the current OBT holding tier of the user
   * @param holdingTier
   */
  @Mutation
  public SET_CURRENT_HOLDING_TIER(holdingTier: OBTHoldingTier) {
    this.currentOBTHoldingTier = holdingTier;
  }

  /**
   * 👾 Updates the current OBT holding tier of the user
   * @param holdingTier
   */
  @Mutation
  public SET_ALL_HOLDING_TIERS(holdingTiers: OBTHoldingTier[]) {
    this.allOBTHoldingTiers = holdingTiers;
  }

  /**
   * 🚀 Fetches the current user's holding tier
   */
  @Action
  public fetchCurrentOBTHoldingTier() {
    Vue.prototype.$api
      .get("api/v1/currentholdingtier", null)
      .then((response: any) => camelcaseKeys(response.data))
      .then((formattedData: any) =>
        this.context.commit(
          "SET_CURRENT_HOLDING_TIER",
          new OBTHoldingTier(
            formattedData.tier,
            formattedData.discountPct,
            formattedData.requiredObt,
            formattedData.allowedBots,
            formattedData.maxTotalInUse
          )
        )
      );
  }

  /**
   * 🚀 Fetches all of the available OBT holding tiers
   */
  @Action
  public fetchAllOBTHoldingTiers() {
    Vue.prototype.$api
      .get("/api/v1/allholdingtiers", null)
      .then((response: any) => camelcaseKeys(response.data))
      .then((formattedHoldingTiers: any[]) =>
        this.context.commit(
          "SET_ALL_HOLDING_TIERS",
          formattedHoldingTiers.map(
            (formattedData: any) =>
              new OBTHoldingTier(
                formattedData.tier,
                formattedData.discountPct,
                formattedData.requiredObt,
                formattedData.allowedBots,
                formattedData.maxTotalInUse
              )
          )
        )
      );
  }
}
